import type { BoardObject } from '../../core/interfaces/board-object.interface.js';
import type { StickyNote } from './sticky.interface.js';

/**
 * Type-narrowing guard for sticky board objects (TR3).
 *
 * Used by the placement controller, editor controller and renderer registry
 * fallback to fail silently for non-sticky payloads (FC10).
 */
export function isStickyNote(obj: BoardObject): obj is StickyNote {
  return obj.type === 'sticky';
}
